// Formatação e campos compartilhados da página Pedidos > Precificação.

export function formatarMoeda(v, casas = 2) {
  if (v == null || Number.isNaN(Number(v))) return '—';
  return Number(v).toLocaleString('pt-BR', {
    style: 'currency', currency: 'BRL', minimumFractionDigits: casas, maximumFractionDigits: casas,
  });
}

export function formatarData(iso) {
  if (!iso) return '—';
  const data = new Date(iso);
  return Number.isNaN(data.getTime()) ? '—' : data.toLocaleDateString('pt-BR');
}

export function formatarDataHora(iso) {
  if (!iso) return '—';
  return new Date(iso).toLocaleString('pt-BR', { dateStyle: 'short', timeStyle: 'short' });
}

export function formatarCnpj(cnpj) {
  const d = String(cnpj || '').replace(/\D/g, '');
  if (d.length !== 14) return d || '—';
  return d.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5');
}

/** Converte o texto do input numérico em número (vazio → 0). */
export function paraNumero(valor) {
  const n = Number(String(valor).replace(',', '.'));
  return Number.isFinite(n) ? n : 0;
}

export const REGIMES = [
  { valor: 'presumido', label: 'Lucro Presumido' },
  { valor: 'simples', label: 'Simples Nacional' },
];

export const TEXTO_AVISO_IA = 'Este cálculo é uma sugestão gerada com apoio de IA. Confira os valores, as alíquotas e a classificação de ST/antecipação antes de usar o preço.';
